module.exports = __webpack_public_path__ + "assets/img/green_bg_first_team_info.png?72e27ae79d383260d9861434876b01a5";